<template>
  <div class="wrapper" :style="themeColor">
    <div class="nav-bar">
      <div v-if="$route.name !== 'index'" class="back" @click="backUrl">
        <img src="./assets/img/fanhui.png" />
      </div>
      <div class="title">{{ $route.meta.title }}</div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <component :is="loading"></component>
    <float-ball v-if="$route.meta.no_ball !== true" @toClick="recordList"></float-ball>
    <van-popup v-model="show">
      <div style="display: flex;">
        <img style="width: 4rem; height: 4rem; margin-right: 0.4rem;" src="https://img01.ksdmp.com/web/kefu-2.jpg" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import api from '@/api/common'
import { getUserInfo } from '@/utils/auth'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      themeColor: '', // 颜色值
      show: false
    }
  },
  async mounted() {
    // this.getActInfo()
    // 非微信中，返回页面不会重新加载页面，使用 visibilitychange 进行监听
    document.addEventListener('visibilitychange', this.handleVisible)
    if (window.localStorage.getItem('activityInfo')) {
      await this.getActivityInfo()
    } else {
      this.activeInfo()
    }
  },
  methods: {
    backUrl() {
      this.$router.back()
    },
    recordList() {
      this.show = true
    },
    // 获取配置
    async getActInfo() {
      const res = await api.getActInfo()
      if (res) {
      }
    },
    // 判断页面显示隐藏（处理 window.location.href 跳转返回页面不刷新）
    async handleVisible() {
      if (document.visibilityState === 'visible' && window.localStorage.getItem('activityInfo')) {
        await this.getActivityInfo()
      }
    },
    // 关闭
    goBack() {
      window.open('about:blank', '_self')
    },
    async getActivityInfo() {
      const params = {
        activity_id: window.localStorage.getItem('activityInfo')
      }
      const res = await api.getActivityInfo(params)
      if (res) {
        this.activeInfo()
        window.localStorage.removeItem('activityInfo')
      }
    },
    // 获取活动信息
    activeInfo() {
      const activeInfo = getUserInfo()
      // 活动时间
      const startTime = JSON.parse(activeInfo).start_time
      const endTime = JSON.parse(activeInfo).end_time
      if (dayjs().diff(dayjs(startTime)) < 0) {
        this.$toast({
          msg: '活动未开始',
          duration: 2000
        })
      } else if (dayjs().diff(dayjs(endTime)) > 0) {
        this.$toast({
          msg: '活动已结束',
          duration: 2000
        })
      }
      // 主题颜色
      const themeColor = JSON.parse(activeInfo).background_color
      this.themeColor = `--theme: ${themeColor}`
      this.wxConfig.wxMethod(JSON.parse(activeInfo).wx_title, JSON.parse(activeInfo).wx_describe, JSON.parse(activeInfo).activity_url, JSON.parse(activeInfo).wx_theme)
    }
  },
  computed: {
    loading() {
      return resolve => require(['@/components/Loading.vue'], resolve)
    },
    key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  },
  destroyed() {
    const that = this
    document.removeEventListener('visibilitychange', that.handleVisible)
  },
  watch: {}
}
</script>
<style scoped lang="less">
.wrapper {
  background-color: #f7f7f7;
  height: 100%;
  box-sizing: border-box;
  .nav-bar {
    height: 0.64rem;
    background-color: white;
    position: relative;
    .title {
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.64rem;
      text-align: center;
    }
    .back {
      height: 0.64rem;
      width: 1rem;
      position: absolute;
      left: 0;
      top: 0;
      img {
        width: 0.5rem;
        height: 0.5rem;
        margin-top: 0.07rem;
        margin-left: 0.2rem;
      }
    }
  }
}
</style>
